import React from 'react';
import PropTypes from 'prop-types';
import { useContactMethodChoices } from 'src/common/hooks';

function MethodsOfContact({ contactMethods }) {
  const { contactMethodChoices, isLoading, isFetching } = useContactMethodChoices();

  if (isLoading || isFetching) {
    return null;
  }

  const selectedMethods = contactMethodChoices
    .filter((method) => contactMethods.includes(method.value))
    .map((method) => method.display_name)
    .join(', ');

  return <div className="methods-of-contact">{selectedMethods}</div>;
}

MethodsOfContact.propTypes = {
  contactMethods: PropTypes.array.isRequired,
};

export default MethodsOfContact;
